import React from 'react'
import { useNavigate,Navigate } from 'react-router-dom';
import FetchNewsletter from '../components/FetchNewsletter';
import Header from '../partials/Header';


//import Google from './components/Google';
function Personalizenewletter() {
  document.body.classList.remove('personalize');
  document.body.classList.add('personalize-newsletter');

  const navigate = useNavigate();
  const handleCheckChange =(evnt)=>{
    if(evnt==='success')
      //console.log(evnt);
      navigate('/personalize-end');
    }
    if (!localStorage.getItem('user-info')) {
    
      return <Navigate to="/" />
    
  }else{  return (
    <>  
    <Header backhref="#/personalize-sections" skiphref="#/personalize-end" /> 
     <main>
      <div className="grid-container">
      <FetchNewsletter samirCallback = {handleCheckChange}  />
      </div>
    </main>
    </>
  );

}}

export default Personalizenewletter;

